module.exports = "<div id=\"toasts\">\n  <div class=\"ui message animated bounceInRight hidden transition\">\n    <i class=\"close icon\" onclick=\"$(this).closest('.message').transition('scale');\"></i>\n    <div class=\"header\">\n        {{title}}\n    </div>\n    <p>{{message}}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/toast-notification/toast-notification.component.html
// module id = ../../../../../src/app/_components/toast-notification/toast-notification.component.html
// module chunks = main